import React, {useCallback, useEffect, useState} from 'react';
import {Button, Form, Grid, Header, Icon, Input, Label, Message, Segment, Select, Table} from 'semantic-ui-react';
import StringUtils from "../../../../shared/utils/string-utils";
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import {ShortDto} from "../../../../models/short-dto";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {usePerformanceHistoryService} from "../../../../services/backoffice/hooks/usePerformanceHistoryService";
import ClientMonthPerformance from "../../../../models/client-month-performance";
import {PerformanceHistoryFilter} from "../../../../filters/performance-history-filter";
import {useLocation} from "react-router-dom";
import {DriverMonthPerformance} from "../../../../models/driver-month-performance";
import moment from 'moment';
import 'moment/locale/pt-br';

const RelatorioPremiacaoGeralPage = () => {
    const [logs, setLogs] = useState<ClientMonthPerformance>()
    const [loading, setLoading] = useState<boolean>(false)
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const [clients, setClients] = useState<ShortDto[]>([]);
    const {getAllClientsShortDto} = useClientService();
    const {getClientMonthPerformanceHistory, getToExcelClientMonthPerformanceHistory} = usePerformanceHistoryService();
    const [clientId, setClientId] = useState<string>();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mesParam = queryParams.get("Year") ?? (new Date().getMonth() + 1).toString();
    const anoParam = queryParams.get("Month") ?? new Date().getFullYear().toString();
    const [filter, setFilter] = useState<PerformanceHistoryFilter>({
        Month: parseInt(mesParam),
        Year: parseInt(anoParam),
        // MotoristaNome: '',
        // MotoristaCpf: '',
    })
    moment.locale('pt-br');

    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        getClientMonrhPerformance();
    }, [filter?.Page]);

    useEffect(() => {
        function ListClients() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        ListClients()
    }, [])

    const getClientMonrhPerformance = useCallback(async () => {
        try {
            setLoading(true)
            if (clientId && filter.Month && filter.Year) {
                const response = await getClientMonthPerformanceHistory(clientId, filter).finally(() => setLoading(false));
                setLogs(response.data);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }, [getClientMonthPerformanceHistory])

    async function downloadExcel() {
        try {
            setLoading(true);
            if (clientId && filter.Month && filter.Year) {
                const excelBlob = await getToExcelClientMonthPerformanceHistory(clientId, filter);

                const url = window.URL.createObjectURL(new Blob([excelBlob]));

                const a = document.createElement('a');
                a.href = url;
                a.download = 'relatorio-excel.xlsx'; // Nome do arquivo Excel
                a.click();

                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }

    const handleDateChange = (field: string, value: string) => {
        const date = new Date(value);
        const localDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        setFilter((prevFilter) => ({
            ...prevFilter,
            [field]: localDate
        }));
    };





    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Relatório geral de premiação
            </Header>
            <Table.Row>
                <Table.HeaderCell colSpan="4">
                    <Button onClick={() => setShowFilters(!showFilters)} color={"green"}>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                    <Button onClick={() => downloadExcel()}
                            color={'green'}
                    >
                        <Icon name={'download'}/>
                        {'Download em excel (filtrado)'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>
            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Input
                                    fluid
                                    id="motoristaNome"
                                    type="text"
                                    placeholder="Nome do motorista"
                                    value={filter?.MotoristaNome ?? ''}
                                    onChange={(event) =>
                                        setFilter({...filter, MotoristaNome: event.target?.value})}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <Input
                                    fluid
                                    id="motoristaCpf"
                                    icon="search"
                                    type="text"
                                    placeholder="CPF do motorista"
                                    value={filter?.MotoristaCpf ?? ''}
                                    onChange={(event) =>
                                        setFilter({...filter, MotoristaCpf: event.target?.value})
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={getClientMonrhPerformance}>Filtrar</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}

            <Segment>
                <Grid stackable doubling padded>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Form.Group widths="equal">
                                <Form.Field
                                    width="8"
                                    control={Select}
                                    fluid
                                    label="Cliente"
                                    placeholder="Cliente"
                                    search
                                    selection
                                    options={clients}
                                    value={clientId}
                                    onChange={(_: React.ChangeEvent<HTMLInputElement>, data: { value: string }) => {
                                        setClientId(data.value);
                                    }}
                                />
                            </Form.Group>
                        </Grid.Column>
                        <Grid.Column width={4} verticalAlign="bottom">
                            <Input
                                fluid
                                id="inicioIntervalo"
                                type="date"
                                placeholder="Início do intervalo"
                                value={filter?.InicioIntervalo ? filter.InicioIntervalo.toLocaleDateString('pt-BR').split('/').reverse().join('-') : ''}
                                onChange={(event) =>
                                    handleDateChange('InicioIntervalo', event.target?.value)}
                            />
                        </Grid.Column>
                        <Grid.Column width={4} verticalAlign="bottom">
                            <Input
                                fluid
                                id="fimIntervalo"
                                type="date"
                                placeholder="Fim do intervalo"
                                value={filter?.FimIntervalo ? filter.FimIntervalo.toLocaleDateString('pt-BR').split('/').reverse().join('-') : ''}
                                onChange={(event) =>
                                    handleDateChange('FimIntervalo', event.target?.value)}
                            />
                        </Grid.Column>


                        <Grid.Column width={2} verticalAlign="bottom">
                            <Button color={"green"} onClick={getClientMonrhPerformance}>Filtrar</Button>
                        </Grid.Column>
                    </Grid.Row>
                    {(!filter?.clientId || !filter?.InicioIntervalo || !filter?.FimIntervalo) && (
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Message icon="info" size="small" info content="Preencha os filtros para continuar."/>
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            </Segment>

            <Table color={"green"} striped selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={12}>
                            {logs && (
                                <Header textAlign={'center'} as={'h4'}>
                                    {`Premiações do cliente ${logs.clientName} - 
                De ${filter.InicioIntervalo
                                        ? new Date(filter.InicioIntervalo).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
                                        : ''} 
                a ${filter.FimIntervalo
                                        ? new Date(filter.FimIntervalo).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
                                        : ''}`}
                                </Header>
                            )}
                        </Table.HeaderCell>

                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell textAlign={'right'}>#</Table.HeaderCell>
                        <Table.HeaderCell> Placa </Table.HeaderCell>
                        <Table.HeaderCell> CPF </Table.HeaderCell>
                        <Table.HeaderCell> Nome </Table.HeaderCell>
                        <Table.HeaderCell> Operação </Table.HeaderCell>
                        <Table.HeaderCell> Carga no motor (%) </Table.HeaderCell>
                        <Table.HeaderCell> Carga no motor ($) </Table.HeaderCell>
                        <Table.HeaderCell> Inércia (%) </Table.HeaderCell>
                        <Table.HeaderCell> Inércia ($) </Table.HeaderCell>
                        <Table.HeaderCell> Prêmio Total ($) </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {logs && logs.performanceByDrivers ? (
                        logs.performanceByDrivers.map((driver: DriverMonthPerformance, driverIndex: number) => (
                            <Table.Row key={driverIndex}>
                                <Table.Cell disabled textAlign="right">#{driverIndex + 1}</Table.Cell>
                                <Table.Cell>
                                    <Label content={StringUtils.formatarPlaca(driver.plate)}></Label>
                                </Table.Cell>
                                <Table.Cell>
                                    <b>{StringUtils.formatCPF(driver.driverCpf)}</b>
                                </Table.Cell>
                                <Table.Cell>
                                    <b>{driver.driverName ?? '-------'}</b>
                                </Table.Cell><Table.Cell>
                                <b>{driver.fleetName ?? '-------'}</b>
                            </Table.Cell>
                                <Table.Cell>{`${StringUtils.toBrazilianDecimalFormat(driver.motorLoadPercentage) ?? ' - '}%`}</Table.Cell>
                                <Table.Cell>{`${StringUtils.formatToBRL(driver.engineLoadPrize) ?? ' - '}`}</Table.Cell>
                                <Table.Cell>{`${StringUtils.toBrazilianDecimalFormat(driver.inertiaPercentage) ?? ' - '}%`}</Table.Cell>
                                <Table.Cell>{`${StringUtils.formatToBRL(driver.inertiaPrize) ?? ' - '}`}</Table.Cell>
                                <Table.Cell>
                                    <Label
                                        content={`${StringUtils.formatToBRL(driver.inertiaPrize + driver.engineLoadPrize) ?? ' - '}`}
                                        className={(driver.inertiaPrize + driver.engineLoadPrize) > 0 ? 'teal' : 'gray'}>
                                    </Label>
                                </Table.Cell>
                            </Table.Row>
                        ))
                    ) : (
                        <Table.Row>
                            <Table.Cell colSpan={9}>Nenhum registro encontrado.</Table.Cell>
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </div>
    );
};

export default RelatorioPremiacaoGeralPage;
